const STORAGE_PREFIX = 'prairi.startupReviewVisit.';

/** Wait after the startup profile is on screen before the Follow tip appears. */
export const STARTUP_REVIEW_CALLOUT_DELAY_MS = 10_000;

/** Six calendar months, matching “hasn’t reviewed a startup for the last 6 months”. */
export function startupReviewCalloutIsDue(lastReviewIso: string | null, now = new Date()): boolean {
  if (!lastReviewIso) return true;
  const last = new Date(lastReviewIso);
  if (Number.isNaN(last.getTime())) return true;
  const cutoff = new Date(now);
  cutoff.setMonth(cutoff.getMonth() - 6);
  return last.getTime() <= cutoff.getTime();
}

export function readStartupReviewVisit(userId: string): string | null {
  try {
    return window.localStorage.getItem(`${STORAGE_PREFIX}${userId}`);
  } catch {
    return null;
  }
}

export function recordStartupReviewVisit(userId: string, now = new Date()): void {
  try {
    window.localStorage.setItem(`${STORAGE_PREFIX}${userId}`, now.toISOString());
  } catch {
    // Private mode can block storage. The callout still closes for this view.
  }
}

export function shouldShowStartupReviewCallout(args: {
  isInvestor: boolean;
  reviewIsDue: boolean;
  alreadyFollowedStartup: boolean;
  scrolledToFeeds: boolean;
  dismissed: boolean;
  elapsedMs: number;
}): boolean {
  if (!args.isInvestor || !args.reviewIsDue) return false;
  if (args.alreadyFollowedStartup || args.scrolledToFeeds || args.dismissed) return false;
  return args.elapsedMs >= STARTUP_REVIEW_CALLOUT_DELAY_MS;
}
